var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 130,
    viewBox: "0 0 143 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_482_18781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.60127 77.3476C-0.801984 69.7045 -0.801986 60.2949 3.60127 52.6518L26.7978 12.3877C31.2134 4.72328 39.3856 4.661e-07 48.231 5.7158e-07L94.532 1.12371e-06C103.377 1.22919e-06 111.55 4.72328 115.965 12.3878L139.162 52.6518C143.565 60.2949 143.565 69.7045 139.162 77.3476L115.965 117.612C111.55 125.276 103.377 129.999 94.532 129.999L48.231 129.999C39.3856 129.999 31.2134 125.276 26.7978 117.612L3.60127 77.3476Z",
    fill: "#E3AA18"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3627 60.703L47.0575 13.3325L39.9141 17.4501L67.2435 64.8625L39.9141 112.275L47.0575 116.393L74.4053 68.9482L129.236 68.9482L129.236 60.703L74.3627 60.703ZM72.1611 64.905L72.0873 64.8625L72.1611 64.82V64.905Z",
    fill: "url(#paint0_radial_482_18781)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6691 76.9083C7.31863 69.5656 7.31863 60.4348 11.6691 53.092L21.7211 36.1263L31.3476 18.9487C35.5295 11.4864 43.4555 6.90649 52.009 7.00974L71.6569 7.24693L91.3047 7.00974C99.8583 6.90649 107.784 11.4864 111.966 18.9487L121.593 36.1263L131.645 53.092C135.995 60.4348 135.995 69.5656 131.645 76.9083L121.593 93.874L111.966 111.052C107.784 118.514 99.8583 123.094 91.3047 122.991L71.6569 122.753L52.009 122.991C43.4555 123.094 35.5295 118.514 31.3476 111.052L21.7211 93.8741L11.6691 76.9083ZM18.7627 57.2949C15.9477 62.0461 15.9477 67.9543 18.7627 72.7054L28.84 89.7139C28.8569 89.7424 28.8734 89.771 28.8896 89.7999L38.5403 107.021C41.2463 111.849 46.3748 114.813 51.9095 114.746L71.6071 114.508C71.6403 114.508 71.6734 114.508 71.7066 114.508L91.4042 114.746C96.9389 114.813 102.067 111.849 104.773 107.021L114.424 89.7999C114.44 89.771 114.457 89.7424 114.474 89.7139L124.551 72.7054C127.366 67.9543 127.366 62.0461 124.551 57.2949L114.474 40.2864C114.457 40.258 114.44 40.2293 114.424 40.2004L104.773 22.9795C102.067 18.151 96.9389 15.1875 91.4043 15.2543L71.7066 15.4921C71.6734 15.4925 71.6403 15.4925 71.6071 15.4921L51.9095 15.2543C46.3748 15.1875 41.2463 18.151 38.5403 22.9795L28.8896 40.2004C28.8734 40.2293 28.8569 40.258 28.84 40.2864L18.7627 57.2949Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3625 32.4941C51.3462 30.7371 53.2118 29.6586 55.2252 29.683L72.3286 29.8896L89.432 29.683C91.4454 29.6586 93.311 30.7371 94.2947 32.4941L102.7 47.5079C104.183 50.1568 103.238 53.5064 100.589 54.9894C97.9405 56.4725 94.5909 55.5273 93.1079 52.8784L86.2981 40.7152L72.395 40.8832C72.3508 40.8838 72.3065 40.8838 72.2622 40.8832L58.3591 40.7152L51.5494 52.8784C51.5278 52.9169 51.5058 52.9551 51.4833 52.9931L44.3766 64.9995L51.4833 77.0059C51.5058 77.0439 51.5278 77.0821 51.5494 77.1206L58.3591 89.2838L72.2622 89.1158C72.3065 89.1153 72.3508 89.1153 72.395 89.1158L86.2981 89.2838L93.1079 77.1206C94.5909 74.4717 97.9405 73.5266 100.589 75.0096C103.238 76.4926 104.183 79.8422 102.7 82.4911L94.2947 97.5049C93.311 99.2619 91.4454 100.34 89.432 100.316L72.3286 100.109L55.2252 100.316C53.2118 100.34 51.3462 99.2619 50.3625 97.5049L41.9891 82.5488L33.2587 67.7994C32.2367 66.0727 32.2367 63.9263 33.2587 62.1996L41.9891 47.4502L50.3625 32.4941Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1758 54.1762C62.1758 52.073 64.4417 50.7492 66.2738 51.782L85.9624 62.8809C87.8274 63.9323 87.8274 66.618 85.9624 67.6693L66.2738 78.7682C64.4417 79.8011 62.1758 78.4772 62.1758 76.3741L62.1758 54.1762Z",
    fill: "#644900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9985 65.6517C73.9913 64.5505 76.4995 65.2732 77.6008 67.266L83.3724 77.7099C84.4737 79.7027 83.751 82.2109 81.7582 83.3122C79.7654 84.4135 77.2572 83.6908 76.1559 81.698L70.3842 71.2541C69.2829 69.2613 70.0057 66.753 71.9985 65.6517Z",
    fill: "#644900"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_482_18781",
    x: -37.2565,
    y: -37.5553,
    width: 217.277,
    height: 205.11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 18.7776
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_482_18781"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_482_18781",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.77774
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.88887
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_482_18781"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.1108
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_482_18781",
    result: "effect3_innerShadow_482_18781"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_482_18781",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.0938 64.8253) rotate(-56.2807) scale(60.5947 60.5572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECB3D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.e7f416e7bfa6609c61d390b041df7804.svg";
export { ForwardRef as ReactComponent };